var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 12.5,
    stroke: "#7E808D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9039 19.1C19.2353 19.1 19.5039 18.8314 19.5039 18.5C19.5039 18.1686 19.2353 17.9 18.9039 17.9V19.1ZM15.9378 18.5H15.3378V19.1H15.9378V18.5ZM16.5378 15.5339C16.5378 15.2025 16.2692 14.9339 15.9378 14.9339C15.6065 14.9339 15.3378 15.2025 15.3378 15.5339H16.5378ZM15.6 22C15.6 21.6686 15.3314 21.4 15 21.4C14.6686 21.4 14.4 21.6686 14.4 22H15.6ZM18.9039 18.5V17.9H15.9378V18.5V19.1H18.9039V18.5ZM15.9378 18.5H16.5378V15.5339H15.9378H15.3378V18.5H15.9378ZM15 22H14.4C14.4 26.1974 17.8026 29.6 22 29.6V29V28.4C18.4654 28.4 15.6 25.5346 15.6 22H15ZM22 29V29.6C26.1974 29.6 29.6 26.1974 29.6 22H29H28.4C28.4 25.5346 25.5346 28.4 22 28.4V29ZM29 22H29.6C29.6 17.8026 26.1974 14.4 22 14.4V15V15.6C25.5346 15.6 28.4 18.4654 28.4 22H29ZM22 15V14.4C19.1864 14.4 16.7307 15.9292 15.4175 18.1989L15.9368 18.4994L16.4561 18.7999C17.5637 16.8857 19.6321 15.6 22 15.6V15Z",
    fill: "#212330"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/RefreshIcon.c0fde7384e50b2e060cd8ab38c65f4c6.svg";
export { ForwardRef as ReactComponent };